var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImageFileEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.1733 19.8271L20 30.0005L15 31.0005L16 26.0005L26.1733 15.8271C26.4351 15.5649 26.7461 15.3569 27.0883 15.215C27.4306 15.0731 27.7975 15 28.168 15C28.5385 15 28.9054 15.0731 29.2477 15.215C29.5899 15.3569 29.9009 15.5649 30.1627 15.8271L30.1733 15.8378C30.4355 16.0996 30.6436 16.4105 30.7855 16.7528C30.9274 17.0951 31.0005 17.4619 31.0005 17.8325C31.0005 18.203 30.9274 18.5699 30.7855 18.9122C30.6436 19.2544 30.4355 19.5653 30.1733 19.8271V19.8271Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11 27H3C2.46957 27 1.96086 26.7893 1.58579 26.4142C1.21071 26.0391 1 25.5304 1 25V3C1 2.46957 1.21071 1.96086 1.58579 1.58579C1.96086 1.21071 2.46957 1 3 1H17.172C17.7021 1.00011 18.2104 1.21064 18.5853 1.58533L22.4147 5.41467C22.7894 5.7896 22.9999 6.29794 23 6.828V11",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9C6.80222 9 6.60888 8.94135 6.44443 8.83147C6.27998 8.72159 6.15181 8.56541 6.07612 8.38268C6.00043 8.19996 5.98063 7.99889 6.01921 7.80491C6.0578 7.61093 6.15304 7.43275 6.29289 7.29289C6.43275 7.15304 6.61093 7.0578 6.80491 7.01921C6.99889 6.98063 7.19996 7.00043 7.38268 7.07612C7.56541 7.15181 7.72159 7.27998 7.83147 7.44443C7.94135 7.60888 8 7.80222 8 8C8 8.26522 7.89464 8.51957 7.70711 8.70711C7.51957 8.89464 7.26522 9 7 9Z",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M17.3333 14.7242L15 11.0015C14.9099 10.866 14.7881 10.7545 14.6451 10.6768C14.5021 10.5991 14.3423 10.5576 14.1796 10.5557C14.0169 10.5539 13.8562 10.5918 13.7115 10.6663C13.5668 10.7407 13.4425 10.8494 13.3493 10.9828L10.6827 14.7842L9.04 13.4682C8.93179 13.3814 8.80673 13.3181 8.67275 13.2823C8.53877 13.2465 8.39881 13.239 8.26175 13.2602C8.1247 13.2814 7.99356 13.3308 7.87665 13.4054C7.75974 13.48 7.65963 13.5781 7.58267 13.6935L5 19.0015H13",
    stroke: "currentColor",
    strokeWidth: 2.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImageFileEdit);
export default __webpack_public_path__ + "static/media/ImageFileEdit.211779e93ffbc3e5171292b2a195852a.svg";
export { ForwardRef as ReactComponent };